import { values, sortBy, reverse } from 'libraries/lodash'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import connect from 'front-end-core/decorators/connect'
import { requestFilteredComments } from 'services/CommentsService'
import Comments from 'pages/comments/Comments'

export default connect(({ category, order, users, privacy, archived }) => ({
  filteredComments: requestFilteredComments({ category, users, order, privacy, archived })
    .map(mapResponse(
      ({ entries }) => {
        const unsorted = values(entries)
        const sorted = sortBy(unsorted, 'dateCreated')

        const displayedSort = order !== 'oldest'
          ? reverse(sorted)
          : sorted

        const filteredComments = displayedSort.map(commentNode => ({ commentNode }))

        return filteredComments
      }
    ))
}))(Comments)
